<template>
  <basic-container>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="onLoad"
               @on-load="onLoad_">
               
  <template slot="menu" slot-scope="scope">
     <el-button 
     icon="el-icon-check" 
     v-if="parseInt(scope.row.applyStatus)==2" 
     type="text" 
     @click="showAuditDialog(scope.row)" 
     size="small"
    >缴费</el-button>
  </template>
      <template slot="menuRight">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-search"
                   @click="searchChange_">搜索
        </el-button>
        <el-button type="default"
                   size="small"
                   icon="el-icon-delete"
                   @click="searchReset">清空
        </el-button>
      </template>
               <template slot="userFlag" slot-scope="scope">
                 <div>
                   {{scope.row.userFlag>0?'使用中':'未使用'}}
                 </div>
                </template>

               <template slot="requiredFlag" slot-scope="scope">
                 <div>
                   {{scope.row.requiredFlag>0?'是':'否'}}
                 </div>
                </template>

               <template slot="projectIdForm" slot-scope="scope">
        <el-select
          v-model="form.projectId"
          placeholder="请选择项目名称"
          style="width: 100%"
          @change="(value)=>projectChange(value,1)"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="typeForm" slot-scope="scope">
        <el-select
          v-model="form.type"
          placeholder="请选择项目名称"
          style="width: 100%"
          @change="(value)=>typeChange(value)"
        >
          <el-option
            v-for="item in typeList"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </template>

      
      <template slot="venueIdForm" slot-scope="scope">
        <el-select
          v-model="form.venueId"
          placeholder="请选择场馆名称"
          style="width: 100%"
          @change="(value)=>venueNameChange(value,1)"
        >
          <el-option
            v-for="item in venueNameList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="areaIdForm" slot-scope="scope">
        <el-select
          v-model="form.areaId"
          placeholder="请选择区域名称"
          style="width: 100%"
          @change="(value)=>areaChange(value,1)"
        >
          <el-option
            v-for="item in areaList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      
      <template slot="chargeTypeForm" slot-scope="scope">
        <el-select
          v-model="form.chargeType"
          placeholder="请选择区域名称"
          style="width: 100%"
          @change="(value)=>chargeTypeChange(value,1)"
        >
          <el-option
            v-for="item in chargeTypeList"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </template>

      <template slot="feeForm" slot-scope="scope">
        <div>
          <el-input
            v-model="form.fee"
            style="width:calc(100% - 2rem)"
          ></el-input>{{form.chargeType==2?' %':' /元'}}
        </div>
      </template>
      <template slot="userFlagForm" slot-scope="scope">
          <el-radio-group v-model="form.userFlag">
            <el-radio :label="0">未使用</el-radio>
            <el-radio :label="1">使用中</el-radio>
          </el-radio-group>
      </template>
      <template slot="requiredFlagForm" slot-scope="scope">
          <el-radio-group v-model="form.requiredFlag">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
      </template>
      
      <template slot="venueIdSearch" slot-scope="scope">
        <el-select
          v-model="query.venueId"
          placeholder="请选择场馆名称"
          style="width: 100%"
          @change="(value)=>venueNameChange(value,1)"
        >
          <el-option
            v-for="item in venueNameList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="nameSearch" slot-scope="scope">
        <div>
          <el-input
            v-model="query.name"
          placeholder="请输入服务名称"
          ></el-input>
        </div>
      </template>
      <template slot="chargeTypeSearch" slot-scope="scope">
        <el-select
          v-model="query.chargeType"
          placeholder="请选择区域名称"
          style="width: 100%"
          @change="(value)=>chargeTypeChange(value)"
        >
          <el-option
            v-for="item in chargeTypeList"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="applyStatusSearch" slot-scope="scope">
        <el-select
          v-model="query.applyStatus"
          placeholder="请选择区域名称"
          style="width: 100%"
          @change="(value)=>applyStatusChange(value)"
        >
          <el-option
            v-for="item in applyStatusList"
            :key="item.dictKey"
            :label="item.dictValue"
            :value="item.dictKey"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="projectIdSearch" slot-scope="scope">
        <el-select
          v-model="query.projectId"
          placeholder="请选择项目名称"
          style="width: 100%"
          @change="(value)=>projectChange(value)"
        >
          <el-option
            v-for="item in projectList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="areaIdSearch" slot-scope="scope">
        <el-select
          v-model="query.areaId"
          placeholder="请选择区域名称"
          style="width: 100%"
          @change="(value)=>areaChange(value)"
        >
          <el-option
            v-for="item in areaList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </template>


      <template slot="showsearchBtnSearch" slot-scope="scope">
        <el-button type="text" size="small" v-if="showMoreBtnFlag" @click="showMoreSearchContent('')">更多查询</el-button>
        <el-button type="text" size="small" v-if="!showMoreBtnFlag" @click="showMoreSearchContent('none')">隐藏查询</el-button>
      </template>
    </avue-crud>
    
  <el-dialog 
  title="场馆租赁缴费详情" 
  v-if="dialogFormVisibleDetail" 
  :visible.sync="dialogFormVisibleDetail" 
  append-to-body>
    <div>
        
    <detail-form-dialog-detail
         ref="detailFormDialogDetail"
         @detailClose="handleCloseDetailDialog"
        :dialogFormVisibleDetail.sync="dialogFormVisibleDetail"
        :detailForm.sync="detailForm"
        :projectList.sync="projectList"
        :areaList.sync="areaList"
        :typeList.sync="typeList"
        :venueList.sync="venueList"
    ></detail-form-dialog-detail>
    </div>
  </el-dialog>
  </basic-container>
</template>

<script>
  import $ from 'jquery';
  import {add, getDetail, getList, remove, update, getAreaList, getVenueNameList, getVenueTypeList, getVenueChargeTypeList, getApplyStatusList} from "@/api/v4ward/stadium-management/charge";

  import {getProjectList} from "@/api/crmedical/project/project";
    
    import DetailFormDialogDetail from './stadium-charge-dialog-detail';

  export default {
      components:{DetailFormDialogDetail},
    data() {
      return {
        showMoreBtnFlag:true,
          detailForm:{},
        dialogFormVisibleDetail:false,
        venueNameList:[],
        projectList:[],
        areaList:[],
        form: {
          requiredFlag:1,
          userFlag:1
        },
        query: {
            type:'',
        },
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {
          // menu:false,
          // menuBtn:false,
          addBtn:false,
          emptyBtn:false,
          searchBtn:false,
          columnBtn:false,
          height: 'auto',
          calcHeight: 90,
          tip: false,
          // searchShow: false,
          searchShowBtn:false,
          // searchMenuSpan: 6,
          border: true,
          index: true,
          indexLabel:"序号",
          editBtn: false,
          viewBtn: false,
          delBtn: false,
          selection: false,
          dialogClickModal: false,
          refreshBtn:false,

          column: [
              
            {
              label: "项目名称",
              prop: "projectName",
              search: false,
              viewDisplay:false,
              addDisplay:false,
              editDisplay:false,
            },
            {
              label: "项目名称",
              prop: "projectId",
              hide:true,
              searchslot:true,
              searchClearable: false,
              formslot:true,
              search: true,
              type: 'tree',
              span:12,
              labelWidth:150,
              props: {
                label: 'name',
                value: 'id',
              },
              rules: [{
                required: true,
                message: "请输入项目名称",
                trigger: "blur"
              }]
            },
            {
              label: "区域名称",
              prop: "areaName",
              search: false,
              viewDisplay:false,
              addDisplay:false,
              editDisplay:false,
            },
            {
              label: "区域名称",
              prop: "areaId",
              span:12,
              labelWidth:150,
              search:true,
              hide:true,
              searchslot:true,
              formslot:true,
              rules: [{
                required: true,
                message: "请输入区域名称",
                trigger: "blur"
              }]
            },
            {
              label: "场馆类型",
              prop: "type",
              span:12,
              labelWidth:150,
              formslot:true,
              search:true,
              type: 'select',
              dataType: 'number',
              change:(value,column)=>{
                  console.log(value,column);
                  this.query.type = value.value;
                  let self = this;
                  this.triggerGetVenueList('',()=>{
                    if(self.venueNameList&&self.venueNameList.length>0){
                      self.query.venueId = self.venueNameList[0].id;
                      self.$refs.crud.$refs.headerSearch.searchForm.venueId=self.venueNameList[0].id;
                    }
                  });
              },
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=venue_type',
              rules: [{
                required: true,
                message: "请输入场馆类型",
                trigger: "blur"
              }]
            },
            {
              label: "场馆名称",
              prop: "name",
              search:false,
            },
            {
              label: "场馆名称",
              prop: "venueId",
              formslot:true,
              searchslot:true,
              search:true,
              hide:true,
              span:12,
              labelWidth:150,
              rules: [{
                required: true,
                message: "请输入场馆名称",
                trigger: "change"
              }]
            },
            {
              label: "申请时间",
              prop: "createTime",
              search:false,
              hide:false,
              searchslot:false,
              viewDisplay:false,
              addDisplay:false,
              editDisplay:false,
            },
            {
              label: "预定起期",
              prop: "startTime",
              type:'date',
              format:'yyyy-MM-dd HH:mm:ss',
              valueFormat:'yyyy-MM-dd HH:mm:ss',
              search:true,
              change:(value)=>{
                this.query = Object.assign({},this.query,{
                    startTime:value.value
                });
              }
            },
            {
              label: "预定止期",
              prop: "endTime",
              type:'date',
              format:'yyyy-MM-dd HH:mm:ss',
              valueFormat:'yyyy-MM-dd HH:mm:ss',
              search:true,
              change:(value)=>{
                this.query = Object.assign({},this.query,{
                    endTime:value.value
                });
              }
            },
            {
              label: "费用总额(元)",
              prop: "totalAmount",
              search:false,
              hide:false,
              searchslot:false,
              viewDisplay:false,
              addDisplay:false,
              editDisplay:false,
            },
            {
              label: "状态",
              prop: "applyStatus",
              span:12,
              labelWidth:150,
              formslot:true,
              search:true,
              searchslot:true,
              type: 'select',
              dataType: 'number',
              change:(value)=>{
                this.query.applyStatus = value.value;
              },
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=venue_apply_status',
              rules: [{
                required: true,
                message: "请输入场馆类型",
                trigger: "blur"
              }]
            },
            {
              label: "租用公司",
              prop: "applyCompany",
              search:true,
            },
            {
              label: "申请人",
              prop: "applyName",
              search:true,
              change:(value)=>{
                this.query = Object.assign({},this.query,{
                    applyName:value.value
                });
              }
            },
            
            {
              label: "手机号",
              prop: "applyPhone",
              search:true,
            },
            {
              label: "证件号",
              prop: "applyCertNo",
              search:true,
            },
            
            {
              label: "",
              prop: "showsearchBtn",
              search:true,
              hide:true,
              searchslot:true,
              viewDisplay:false,
              addDisplay:false,
              editDisplay:false,
            },
            {
              label: "收费类型",
              prop: "chargeType",
              span:12,
              labelWidth:150,
              formslot:true,
              hide:true,
              search:false,
              searchslot:true,
              type: 'select',
              dataType: 'number',
              props: {
                label: 'dictValue',
                value: 'dictKey',
              },
              dicUrl: '/api/blade-system/dict/dictionaryWithIntKey?code=venue_charge_type',
              rules: [{
                required: true,
                message: "请输入场馆类型",
                trigger: "blur"
              }]
            },
            {
              label: "服务名称",
              hide:true,
              search:false,
              searchslot:true,
              prop: "",
              span:12,
              labelWidth:150,
              rules: [{
                required: true,
                message: "服务名称",
                trigger: "change"
              }]
            },
            
            {
              label: "服务费",
              hide:true,
              prop: "fee",
              span:12,
              labelWidth:150,
              formslot:true,
              // addDisplay:false,
              // editDisplay:false,
              rules: [{
                required: true,
                message: "请输入服务费",
                trigger: "change"
              }]
            },
            {
              label: "",
              prop: "",
              hide:true,
              formslot:true,
              span:12,
              labelWidth:150,
            },
            {
              label: "状态",
              prop: "userFlag",
              hide:true,
              formslot:true,
              slot:true,
              span:12,
              labelWidth:150,
              // addDisplay:false,
              // editDisplay:false,
            },
            {
              label: "是否必选配置",
              prop: "requiredFlag",
              formslot:true,
              hide:true,
              slot:true,
              labelWidth:150,
              span:12,
              // addDisplay:false,
              // editDisplay:false,
            },
            {
              label: "服务说明",
              prop: "description",
              type:'textarea',
              maxlength:500,
              showWordLimit:true,
              labelWidth:150,
              span:24,
              hide:true,
            },
	
          ]
        },
        data: []
      };
    },
    computed: {
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    mounted(){
        this.resetSearchHeaderStyle();
        console.log("mounted===========>",this.$refs.crud);
        this.$refs.crud.$refs.headerSearch.option.dicData.applyStatus=[]
        let dicDatas = this.$refs.crud.$refs.headerSearch.option.dicData;
        setTimeout(()=>{
          this.$refs.crud.doLayout();
          this.$refs.crud.$refs.headerSearch.$refs.form.$refs.applyStatus[0]= Object.assign({},this.$refs.crud.$refs.headerSearch.$refs.form.$refs.applyStatus[0],{
            dic:[]
          })
        console.log("mounted===========>",this.$refs.crud.$refs.headerSearch.$refs.form.$refs.applyStatus[0]);
          console.log(this.$refs.crud.$refs.headerSearch.$refs.form.$refs.applyStatus[0].$el);
          console.log(this.$refs.crud.$refs.headerSearch.$refs.form.$refs.applyStatus[0]);
        });
      setTimeout(()=>{
        this.showMoreSearchContent('none');
      })
    },
    activated(){
        this.$refs.crud.doLayout();
    },
    created(){
      getVenueTypeList().then((res)=>{
        this.typeList = res.data;
      });
      getVenueChargeTypeList().then((res)=>{
        let arr = [];
        res.data.forEach((ele)=>{
          if(ele.dictValue==3||ele.dictValue==2){
            arr.push(ele);
          }
        });
        this.chargeTypeList = res.data;
      });
      getProjectList().then((res)=>{
        this.projectList = res.data;
      })
    },
    methods: {
      applyStatusChange(value){
        this.query = Object.assign({},this.query,{
          applyStatus:value
        })
      },
      showMoreSearchContent(flag){
        let domListItem = this.$refs.crud.$refs.headerSearch.$el.querySelectorAll('.avue-form__item--');
        //  this.showMoreBtnFlag = !this.showMoreBtnFlag;
        // let tempNode=document.getElementById("myList2").lastChild;
        // document.getElementById("myList1").appendChild(tempNode);
          let applyNameNode='';
          let applyStatusNode='';
          this.showMoreBtnFlag = flag==='none'?true:false;
            domListItem.forEach(ele=>{
              // console.log(ele.querySelector('label').attributes);
              if(ele.querySelector('label')){
                if(ele.querySelector('label').attributes[0].value==='applyCertNo'){
                  ele.style.display=flag;
                }
                if(ele.querySelector('label').attributes[0].value==='applyPhone'){
                  ele.style.display=flag;
                }
                if(ele.querySelector('label').attributes[0].value==='applyCompany'){
                  ele.style.display=flag;
                }
                if(ele.querySelector('label').attributes[0].value==='applyName'){
                  applyNameNode = ele;
                }
                if(ele.querySelector('label').attributes[0].value==='applyStatus'){
                  applyStatusNode = ele;
                }
                
              }
            });
            // console.log(applyNameNode.parent);
            $(applyNameNode.parentNode).insertAfter(applyStatusNode.parentNode);
      },
        resetSearchHeaderStyle(){
          let searchDom = this.$refs.crud.$refs.headerSearch.$el;
            let domListLabel = searchDom.querySelectorAll('label');
            let domListContent = searchDom.querySelectorAll('.el-form-item__content');
            let domListItem = searchDom.querySelectorAll('.avue-form__item--');
            
            domListLabel.forEach(ele=>{
                ele.style.cssText='width:100px;'
            });
            domListContent.forEach(ele=>{
                ele.style.cssText='margin-left:100px;'
            });
            domListItem.forEach(ele=>{
                ele.style.cssText='width:100%;'
            });
        },
        handleCloseDetailDialog(value){
            this.dialogFormVisibleDetail = value;
            this.onLoad();
        },
        showAuditDialog(row){
            console.log(row);
            getDetail({id:row.id}).then(({data})=>{
                this.detailForm = data;
                this.dialogFormVisibleDetail = true;
            });
        },
      chargeTypeChange(value){
          
      },
      projectChange(value,type){
        if(type){
          this.form.projectId = value;
          this.form.areaId = '';
          this.form.applyStatus = '';
          // this.form.applyStatus=this.applyStatusList[0].dictKey;
          // this.$refs.crud.$refs.headerSearch.searchForm.applyStatus=this.applyStatusList[0].dictKey;
        
        }else{
          this.query.projectId = value;
          this.query.areaId = '';
          this.query.applyStatus = '';
          // this.query.applyStatus=this.applyStatusList[0].dictKey;
          // this.$refs.crud.$refs.headerSearch.searchForm.applyStatus=this.applyStatusList[0].dictKey;
        
        }
        getAreaList({ projectId: value }).then(({ data })=>{
          console.log("getAreaList=====>",data);
          this.areaList = data;

          let self = this;
            self.query.type = self.typeList[0].dictKey;
            self.$refs.crud.$refs.headerSearch.searchForm.type = self.typeList[0].dictKey;
            self.query.areaId = self.areaList[0].id;
            self.$refs.crud.$refs.headerSearch.searchForm.areaId = self.areaList[0].id;
          this.triggerGetVenueList('',()=>{
            if(self.venueNameList&&self.venueNameList.length>0){
              self.query.venueId = self.venueNameList[0].id;
              self.$refs.crud.$refs.headerSearch.searchForm.venueId=self.venueNameList[0].id;
            }
          });
          this.$forceUpdate();
        });
      },
      areaChange(value,type){
        let self = this;
        if(type){
          self.form = Object.assign({},self.form,{
            areaId:value
          });
        }else{
          self.query = Object.assign({},self.query,{
            areaId:value
          });
          self.$refs.crud.$refs.headerSearch.searchForm.areaId = value;
        }
            self.query.type = self.typeList[0].dictKey;
            self.$refs.crud.$refs.headerSearch.searchForm.type = self.typeList[0].dictKey;
            
        self.triggerGetVenueList('',()=>{
            if(self.venueNameList&&self.venueNameList.length>0){
              self.query.venueId = self.venueNameList[0].id;
              self.$refs.crud.$refs.headerSearch.searchForm.venueId=self.venueNameList[0].id;
            }
        });
      },
      typeChange(value){
        this.form = Object.assign({},this.form,{
          type:value
        });
        this.triggerGetVenueList();
      },
      venueNameChange(value){
        this.form = Object.assign({},this.form,{
          venueId:value
        });
      },
      triggerGetVenueList(type,callback){
        this.form.venueId = '';
        this.query.venueId = '';
        this.venueNameList = [];
        if(this.form.areaId&&this.form.projectId&&this.form.type){
          
          if(!type){
            this.$refs.crud.$refs.dialogForm.$refs.tableForm.form.venueId = '';
          }

          // console.log(this.$refs.crud.$refs.dialogForm.$refs.tableForm.form.venueName,this.form);
          console.log('===================triggerGetVenueList===================');
          getVenueNameList({areaId:this.form.areaId,projectId:this.form.projectId,type:this.form.type}).then((res)=>{
            console.log(res);
            this.venueNameList = res.data;
            callback();
          });
        }else if(this.query.areaId&&this.query.projectId&&this.query.type){
            getVenueNameList({areaId:this.query.areaId,projectId:this.query.projectId,type:this.query.type}).then((res)=>{
            console.log(res);
            this.venueNameList = res.data;
            callback();
          });
        }
      },
      rowSave(row, done, loading) {
        add(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdate(row, index, done, loading) {
        update(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        console.log(this.form);
        let type_venue = this.form.type;
        if (["edit", "view"].includes(type)) {
          getDetail({id: this.form.id}).then(({data}) => {
            this.form = data;
            this.form.type = type_venue;
            getAreaList({ projectId: this.form.projectId }).then(({ data })=>{
              console.log("getAreaList=====>",data);
              this.areaList = data;
            });
            this.triggerGetVenueList(1);
          });
        }else{
          this.form = Object.assign({},this.form,{
            userFlag:1,
            requiredFlag:1
          })
        }
        done();
      },
            
      searchReset() {
        // this.query = Object.assign({},this.query,{});
        // setTimeout(()=>{
          let searchDom = this.$refs.crud.$refs.headerSearch
            let projectId = this.query.projectId;
        console.log(searchDom.$refs.form);
        this.query = {};
        console.log(searchDom.$refs.form.resetForm());
        this.query.projectId = projectId;
        this.query.type = '';
        searchDom.searchForm.type='';
            this.query.applyStatus = '';
        searchDom.searchForm.applyStatus='';
            this.query.areaId = '';
        searchDom.searchForm.areaId='';


            this.query.startTime = '';
        this.$refs.crud.$refs.headerSearch.searchForm.startTime='';
            this.query.endTime = '';
        this.$refs.crud.$refs.headerSearch.searchForm.endTime='';

            this.query.applyName = '';
        this.$refs.crud.$refs.headerSearch.searchForm.applyName='';
            this.query.applyCompany = '';
        this.$refs.crud.$refs.headerSearch.searchForm.applyCompany='';
            this.query.applyPhone = '';
        this.$refs.crud.$refs.headerSearch.searchForm.applyPhone='';
            this.query.applyCertNo = '';
        this.$refs.crud.$refs.headerSearch.searchForm.applyCertNo='';


        this.query.type = '';
        this.$refs.crud.$refs.headerSearch.searchForm.type='';
            this.query.applyStatus = '';
        this.$refs.crud.$refs.headerSearch.searchForm.applyStatus='';
            this.query.areaId = '';
        this.$refs.crud.$refs.headerSearch.searchForm.areaId='';
        if(this.venueNameList&&this.venueNameList.length>0){
          this.query.venueId = '';
          this.$refs.crud.$refs.headerSearch.searchForm.venueId='';
        }


        // this.query.type = this.typeList[0].dictKey;
        // this.$refs.crud.$refs.headerSearch.searchForm.type=this.typeList[0].dictKey;
        //     this.query.applyStatus = this.applyStatusList[0].dictKey;
        // this.$refs.crud.$refs.headerSearch.searchForm.applyStatus=this.applyStatusList[0].dictKey;
        //     this.query.areaId = this.areaList[0].id;
        // this.$refs.crud.$refs.headerSearch.searchForm.areaId=this.areaList[0].id;
        // if(this.venueNameList&&this.venueNameList.length>0){
        //   this.query.venueId = this.venueNameList[0].id;
        //   searchDom.searchForm.venueId=this.venueNameList[0].id;
        // }
        // });
        // });
        this.onLoad();
      },
      searchChange_(){
        this.query = Object.assign({},this.query,{});
        this.page.currentPage = 1;
        this.onLoad();
      },
      searchChange(params, done) {
        // this.query = params;
        this.query = Object.assign({},this.query,params);
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      
      onLoad_(page){
        page = page || this.page;
        this.loading = true;
        if(this.query.projectId){
          console.log();
          this.onLoad(page);
          return;
        }else{
          getVenueTypeList().then(({data})=>{
          this.typeList = data;
          console.log(this.$refs.crud.$refs.headerSearch.searchForm);
            this.$refs.crud.$refs.headerSearch.searchForm.type=this.typeList[0].dictKey;
            getApplyStatusList().then((res)=>{
              let arr = []
              res.data.forEach((ele)=>{
                if(ele.dictKey==2||ele.dictKey==3){
                  arr.push(ele);
                }
              })
              this.applyStatusList = arr;
              this.$refs.crud.$refs.headerSearch.searchForm.applyStatus=this.applyStatusList[0].dictKey;
            
              getProjectList().then((res)=>{
                this.projectList = res.data;
                this.projectList_ = res.data;
                this.query.projectId = res.data[0].id;
                this.query.type = this.typeList[0].dictKey;
                this.query.applyStatus = this.applyStatusList[0].dictKey;
            getAreaList({projectId:res.data[0].id}).then((res)=>{
              console.log(res.data);
              this.areaList = res.data;
              if(this.areaList&&this.areaList.length>0){
                this.query.areaId = this.areaList[0].id;
              }
                getVenueNameList(this.query).then((res)=>{
                  this.venueNameList = res.data;
              if(this.venueNameList&&this.venueNameList.length>0){
                  this.query.venueId = this.venueNameList[0].id;
              }
                  getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                  ).then(({data}) => {
                    this.page.total = data.total;
                    this.data = data.records;
                    this.loading = false;
                    this.selectionClear();
                  });
                
                })
            })
              })
            });
            })
        }
      },
      getSearchData(){
        let searchForm = this.$refs.crud.$refs.headerSearch.searchForm;
        this.query = Object.assign({},this.query,{
          applyCompany:searchForm.applyCompany,
          applyPhone:searchForm.applyPhone,
          applyCertNo:searchForm.applyCertNo
        });
      },
      onLoad(page) {
        page = page || this.page;
        this.loading = true;
        this.getSearchData();
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        });
      }
    }
  };
</script>

<style lang="scss" scoped>
// ::v-deep .avue-form__item-- {
//   width:100%!important;
// }
// ::v-deep .el-form-item__label {
//   width:100px!important;
// }
// ::v-deep .el-form-item__content {
//   margin-left:100px!important;
// }
</style>